import React, { useCallback } from 'react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import RenameSimulationDialog from 'client/app/apps/experiments/Workflows/RenameSimulationDialog';
import { SimulationForWorkflow } from 'client/app/apps/workflow-builder/panels/simulations/useSimulations';
import { useSimulationClient } from 'client/app/lib/SimulationClient';
import { ScreenRegistry } from 'client/app/registry';
import MenuItemWithIcon from 'common/ui/components/Menu/MenuItemWithIcon';
import { logEvent } from 'common/ui/GoogleAnalyticsUtils';
import useDialog from 'common/ui/hooks/useDialog';

type Props = {
  simulation: SimulationForWorkflow;
  closeMenu: () => void;
};

export function RenameSimulation({ simulation, closeMenu }: Props) {
  const simulationService = useSimulationClient();

  const [renameSimulationDialog, openRenameSimulationDialog] =
    useDialog(RenameSimulationDialog);

  const handleRenameSimulation = useCallback(async () => {
    closeMenu();
    const updatedSimulationName = await openRenameSimulationDialog({
      screenRegistry: ScreenRegistry.WORKFLOW,
      simulationName: simulation.name,
    });
    if (updatedSimulationName && updatedSimulationName !== simulation.name) {
      logEvent('rename-simulation', ScreenRegistry.WORKFLOW, 'new-name');
      void simulationService.updateSimulation(simulation.id, updatedSimulationName);
    } else {
      logEvent('rename-simulation', ScreenRegistry.WORKFLOW, 'no-change');
    }
  }, [
    closeMenu,
    openRenameSimulationDialog,
    simulation.id,
    simulation.name,
    simulationService,
  ]);

  return (
    <>
      <MenuItemWithIcon
        onClick={handleRenameSimulation}
        icon={<EditOutlinedIcon />}
        text="Rename Simulation"
      />
      {renameSimulationDialog}
    </>
  );
}
